<template>
  <v-container>
    <v-card
      outlined
      class="pa-3 mb-3"
    >
      <v-row dense>
        <v-col
          cols="12"
          md="5"
        >
          <v-text-field
            v-model="filter"
            outlined
            dense
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            label="ຄົ້ນຫາ: ຊື່, ເບີໂທ, CUS_"
            @keyup.enter="load(1)"
            @click:clear="clearFilter"
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
        >
          <v-select
            v-model="statusFilter"
            :items="statusFilters"
            outlined
            dense
            hide-details
            label="ສະຖານະປັດຈຸບັນ"
          />
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="d-flex align-center flex-wrap"
        >
          <v-btn
            color="primary"
            depressed
            class="mr-2 mb-1"
            @click="load(1)"
          >
            <v-icon left>
              mdi-magnify
            </v-icon>
            ຄົ້ນຫາ
          </v-btn>
          <v-btn
            color="success"
            depressed
            class="mr-2 mb-1"
            @click="importDialog = true"
          >
            <v-icon left>
              mdi-file-import
            </v-icon>
            Import Excel
          </v-btn>
          <v-btn
            text
            color="success"
            class="mb-1"
            :loading="downloading"
            @click="downloadTemplate"
          >
            <v-icon left>
              mdi-microsoft-excel
            </v-icon>
            ດາວໂຫລດແບບຟອມ
          </v-btn>
        </v-col>
      </v-row>
      <div class="text-caption grey--text mt-2">
        ສະແດງສະເພາະລູກຄ້າສາຍບ້ານ. ເມື່ອຜ່ານການອະນຸມັດ 3 ຂັ້ນ (ຄົນລະຄົນ):
        <b>active</b> → ເກັບໄດ້, <b>inactive</b> → ເກັບບໍ່ໄດ້.
      </div>
    </v-card>

    <v-card
      v-if="selected.length"
      outlined
      class="pa-3 mb-3"
    >
      <div class="mb-2 font-weight-medium">
        ລູກຄ້າທີ່ເລືອກ {{ selected.length }} ລາຍ
      </div>
      <v-chip
        v-for="c in selected"
        :key="c.id"
        small
        close
        class="mr-1 mb-1"
        @click:close="unselect(c)"
      >
        {{ c.customer_code }} · {{ c.name }} · {{ c.status }}
      </v-chip>
      <v-row
        dense
        class="mt-2"
      >
        <v-col
          cols="12"
          md="4"
        >
          <v-select
            v-model="toStatus"
            :items="toStatuses"
            outlined
            dense
            label="ປ່ຽນເປັນ *"
            :error-messages="toStatusError"
            @change="toStatusError = ''"
          />
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <v-textarea
            v-model="reason"
            outlined
            dense
            rows="1"
            auto-grow
            label="ເຫດຜົນ *"
            :error-messages="reasonError"
            @input="reasonError = ''"
          />
        </v-col>
      </v-row>
      <div class="d-flex">
        <v-spacer />
        <v-btn
          color="primary"
          depressed
          :loading="sending"
          @click="openConfirm"
        >
          <v-icon left>
            mdi-send
          </v-icon>
          ສົ່ງຂໍປິດ/ເປີດ {{ selected.length }} ລາຍ
        </v-btn>
      </div>
    </v-card>

    <v-card outlined>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="customers"
        :loading="loading"
        item-key="id"
        show-select
        selectable-key="selectable"
        :item-class="(item) => (item.selectable ? '' : 'grey lighten-4')"
        hide-default-footer
        disable-pagination
        disable-sort
        no-data-text="ບໍ່ພົບລູກຄ້າ"
      >
        <template v-slot:[`item.name`]="{ item }">
          <div>{{ item.name }}</div>
          <div class="text-caption grey--text">
            {{ item.customer_code }} · {{ item.phone }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            x-small
            :color="item.status === 'inactive' ? 'grey lighten-2' : 'green lighten-4'"
          >
            {{ item.status }}
          </v-chip>
          <span class="text-caption ml-1">{{ collectLabel(item.can_collect) }}</span>
          <div
            v-if="item.open_request_id"
            class="text-caption orange--text text--darken-2"
          >
            ມີຄຳຂໍ #{{ item.open_request_id }} ລໍຖ້າຢູ່
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-if="pagination.total_pages > 1"
        v-model="page"
        :length="pagination.total_pages"
        :total-visible="7"
        class="my-2"
        @input="load"
      />
    </v-card>

    <h3 class="mt-6 mb-2">
      ຄຳຂໍຂອງຂ້ອຍ (ລໍຖ້າ / ຖືກປະຕິເສດ)
    </h3>
    <v-card outlined>
      <v-data-table
        :headers="mineHeaders"
        :items="mine"
        :items-per-page="20"
        no-data-text="ບໍ່ມີຄຳຂໍທີ່ຄ້າງ"
      >
        <template v-slot:[`item.customer_name`]="{ item }">
          <div>{{ item.customer_name }}</div>
          <div class="text-caption grey--text">
            {{ item.customer_code }} · {{ statusChange(item) }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            x-small
            :color="item.status === 'rejected' ? 'red lighten-5' : 'amber lighten-5'"
            :text-color="item.status === 'rejected' ? 'red darken-2' : 'amber darken-4'"
          >
            {{ item.status === 'rejected' ? `ຖືກປະຕິເສດ (ຂັ້ນທີ ${item.step})` : `ລໍຖ້າອະນຸມັດ ຂັ້ນທີ ${item.step}/3` }}
          </v-chip>
          <div
            v-if="item.reject_reason"
            class="text-caption red--text"
          >
            {{ item.reject_reason }}
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="confirm"
      max-width="460"
    >
      <v-card>
        <v-card-title>ຢືນຢັນສົ່ງຂໍປິດ/ເປີດສາຍບ້ານ</v-card-title>
        <v-card-text>
          ສົ່ງຄຳຂໍປ່ຽນ {{ selected.length }} ລາຍ ເປັນ <b>{{ toStatus }}</b>
          ({{ toStatus === 'active' ? 'ເກັບໄດ້' : 'ເກັບບໍ່ໄດ້' }})?
          ຈະປ່ຽນເມື່ອຜ່ານການອະນຸມັດຄົບ 3 ຂັ້ນ.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="confirm = false"
          >
            ຍົກເລີກ
          </v-btn>
          <v-btn
            color="primary"
            depressed
            :loading="sending"
            @click="send"
          >
            ສົ່ງຄຳຂໍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <excel-import-dialog
      v-model="importDialog"
      api="home-status-request"
      title="Import ການປິດ/ເປີດສາຍບ້ານ (Excel)"
      @download-template="downloadTemplate"
      @imported="afterImport"
    >
      ຖັນ A: ລະຫັດລູກຄ້າ (CUS_123), ຖັນ B: ເບີໂທລູກຄ້າ (ຕ້ອງກົງກັບລະຫັດ),
      ຖັນ C: ສະຖານະໃໝ່ (active ຫຼື inactive), ຖັນ D: ເຫດຜົນ. <b>ຕ້ອງໃສ່ຄົບທັງ 4 ຖັນ.</b>
    </excel-import-dialog>
  </v-container>
</template>

<script>
import ExcelImportDialog from '@/views/threeStep/ExcelImportDialog.vue';
import { collectLabel, statusChange } from '@/views/threeStep/cells';

export default {
  name: 'HomeStatusRequest',
  components: { ExcelImportDialog },
  title() {
    return 'Vientiane Waste Co-Dev|Home Status Request';
  },
  data() {
    return {
      filter: '',
      statusFilter: 'all',
      customers: [],
      loading: false,
      page: 1,
      pagination: {},
      selected: [],
      toStatus: null,
      toStatusError: '',
      reason: '',
      reasonError: '',
      confirm: false,
      sending: false,
      mine: [],
      importDialog: false,
      downloading: false,
      statusFilters: [
        { text: 'ທັງໝົດ', value: 'all' },
        { text: 'active', value: 'active' },
        { text: 'inactive', value: 'inactive' },
        { text: 'trial', value: 'trial' },
      ],
      toStatuses: [
        { text: 'ເປີດ: active (ເກັບໄດ້)', value: 'active' },
        { text: 'ປິດ: inactive (ເກັບບໍ່ໄດ້)', value: 'inactive' },
      ],
      headers: [
        { text: 'ລູກຄ້າ', value: 'name' },
        { text: 'ບ້ານ', value: 'village' },
        { text: 'ແພັກເກດ', value: 'package' },
        { text: 'ສະຖານະປັດຈຸບັນ', value: 'status' },
      ],
      mineHeaders: [
        { text: 'ເລກຄຳຂໍ', value: 'id' },
        { text: 'ລູກຄ້າ / ປ່ຽນ', value: 'customer_name', sortable: false },
        { text: 'ເຫດຜົນ', value: 'reason', sortable: false },
        { text: 'ວັນທີສົ່ງ', value: 'created_at' },
        { text: 'ສະຖານະ', value: 'status' },
      ],
    };
  },
  created() {
    this.load(1);
    this.loadMine();
  },
  methods: {
    collectLabel,
    statusChange,
    unselect(c) {
      this.selected = this.selected.filter((s) => s.id !== c.id);
    },
    clearFilter() {
      this.filter = '';
      this.load(1);
    },
    load(page) {
      this.page = page || 1;
      this.loading = true;
      this.$axios
        .get('home-status-request/customers', {
          params: {
            page: this.page,
            per_page: 50,
            filter: this.filter || undefined,
            status: this.statusFilter === 'all' ? undefined : this.statusFilter,
          },
        })
        .then((res) => {
          // A customer with an open status request can't be ticked (select-all too).
          this.customers = (res.data.data.data || []).map((c) => ({ ...c, selectable: !c.open_request_id }));
          this.pagination = res.data.data.pagination || {};
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.loading = false;
        });
    },
    loadMine() {
      this.$axios
        .get('home-status-request', { params: { per_page: 100 } })
        .then((res) => {
          this.mine = res.data.data.data || [];
        })
        .catch(() => {});
    },
    afterImport() {
      this.load(1);
      this.loadMine();
    },
    openConfirm() {
      if (!this.toStatus) this.toStatusError = 'ກະລຸນາເລືອກສະຖານະ';
      if (!this.reason || !this.reason.trim()) this.reasonError = 'ກະລຸນາໃສ່ເຫດຜົນ';
      if (this.toStatusError || this.reasonError) return;
      this.confirm = true;
    },
    send() {
      this.sending = true;
      this.$axios
        .post('home-status-request', {
          customer_ids: this.selected.map((c) => c.id), to_status: this.toStatus, reason: this.reason.trim(),
        })
        .then(() => {
          this.toast('success', 'ສົ່ງຄຳຂໍປິດ/ເປີດສາຍບ້ານແລ້ວ, ລໍຖ້າອະນຸມັດຂັ້ນທີ 1');
          this.selected = [];
          this.reason = '';
          this.toStatus = null;
          this.load(this.page);
          this.loadMine();
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.sending = false;
          this.confirm = false;
        });
    },
    downloadTemplate() {
      this.downloading = true;
      this.$axios
        .get('home-status-request/template', { responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'ແບບຟອມ_ປິດ-ເປີດສາຍບ້ານ.xlsx';
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => this.toast('error', 'ດາວໂຫລດບໍ່ສຳເລັດ'))
        .finally(() => {
          this.downloading = false;
        });
    },
    message(error) {
      return (error.response && error.response.data && error.response.data.message) || 'Something went wrong';
    },
    toast(color, msg) {
      this.$store.commit('Toast_State', { value: true, color, msg });
    },
  },
};
</script>
